<template>
  <div class="page_content stream_career" aria-label="Career View content page">
    <div class="row page-heading">
      <div class="col-7 input module_heading">
        <span class="module_icon icon-stream"></span>
        <label class="head_txt module_type_name ace_sec_hd" role="heading" :aria-label="stream.title"><span v-if="advisorTitle">{{advisorTitle}}: </span>{{stream.title}}</label>
      </div>
      <div class="col-5 right-container">
        <stream-header :uuid="uuid" active="category"></stream-header>
      </div>
    </div>
    <div class="page-content">
      <stream-menu :uuid="uuid" active="career"></stream-menu>
      <div class="col-11 dasboard-left-section" v-if="isCareerProgressAvailable">
        <div class="row">
          <div class="col-12">
            <div class="row">

              <div class="col-12 tabs_container_21">
                <b-card no-body>
                  <b-tabs class="tabs_sec_21" card v-model="tabIndex">

                    <template v-for="(typeAndProgressMap, key, i) in careerProgressMapTypeAndProgressMap">

                      <b-tab :title="competencyTagSourceLabelMap[key]" class="tab_21">

                        <div class="credit-completion-section col-xl-9 col-lg-9 col-md-9 col-sm-9 col-xs-12 float-left">
                          <div class="ace_sec" aria-label="Career View Section" aria-level="1">
                            <div class="credit-completion-pie-chart row">

                              <template v-for="(values, label, index) in typeAndProgressMap">
                                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12 ace_sec_txt" :aria-label="careerTypesMap[label]" style="text-align: center;" tabindex="0">
                                  <div class="pie_chart" :id="'skillPieChart_' + key + '_' + index"></div>
                                  <div class="pie_chart_title" style="margin-top: 12px;">
                                    <template v-if="label === 'TOTAL'">
                                      {{careerTypesMap[label]}}
                                    </template>
                                    <template v-else>
                                      {{careerTypesMap[label]}}
                                    </template>
                                  </div>
                                </div>
                              </template>
                            </div>
                          </div>
                        </div>

                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12 legends float-right" aria-level="2">
                          <div class="row">
                            <div class="col-xl-6 col-lg-12 col-md-6 col-sm-12 col-xs-12 lg_sec_grph">
                              <div class="lg_row ace_sec_txt" aria-label="legend. Completed"><span class="lg_blc gc_completed"></span> Completed </div>
                              <div class="lg_row ace_sec_txt" aria-label="legend. In Progress"><span class="lg_blc gc_in_progress"></span> In Progress </div>
                              <div class="lg_row ace_sec_txt" aria-label="legend. In the Plan"><span class="lg_blc gc_in_plan"></span> In the Plan </div>
                              <div class="lg_row ace_sec_txt" aria-label="legend. Missing"><span class="lg_blc gc_missing"></span>  Missing </div>
                            </div>
                            <div class="col-xl-6 col-lg-12 col-md-6 col-sm-12 col-xs-12 lg_sec_tags">
                              <template v-for="(values, label, index) in typeAndProgressMap">
                                <div class="lg_row" :aria-label="'legend. ' + careerTypesMap[key]" tabindex="0">
                                  <span class="lg_blc " :style="{background: skillTypeColorMap[label]}"></span>
                                    <template v-if="label === 'TOTAL'">
                                      {{careerTypesMap[label]}}
                                    </template>
                                    <template v-else>
                                      {{careerTypesMap[label]}}
                                    </template>
                                </div>
                              </template>
                            </div>
                          </div>
                        </div>

                      </b-tab>

                    </template>

                  </b-tabs>
                </b-card>
              </div>

            </div>
          </div>

          <div class="col-12">
            <template v-for="(typeStatusAndTagMap, key, i) in careerProgressMapTypeStatusAndTagMap">
              <template v-for="(skills, label, j) in typeStatusAndTagMap">
                <div style="margin-top: 30px;" v-if="skills.length > 0">
                  <div class="tag-type-head" :class="{'d-none': (tabIndex !== i)}" role="heading" :aria-label="label + ' skill tags'" aria-level="3" tabindex="0" style="float: left; width: 100%;">
                    <div class="tag-type-status" :style="{background: skillStatusColorMap[label]}">
                      <div class="tag-type-status-circle mr-2 float-left">
                        <span>-</span>
                      </div>
                      <div>{{label}}</div>
                    </div>
                  </div>
                  <div class="tags_section" style="float: left; width: 100%; margin: 0px 0px 12px 15px;">
                    <div class="tags_container">
                      <template v-for="skill in skills">
                        <div class="tag" :class="[skill.type, ((tabIndex !== i) ? 'd-none' : '')]" :id="skill.competencyId" v-bind:aria-label="skill.title + ' tag'" style="cursor: pointer;" @click="openProgressPopup(skill.competencyId)" tabindex="0">
                          <span class="tag_name competency_tag" :title="skill.title">{{skill.title}}</span>
                          <span class="tag_lavel" v-if="skill.level">
                          <span>{{skill.level}}</span>
                          </span>
                        </div>
                        <div id="skillsTagsPopover" class="skills_tag_popover"></div>
                        <b-popover :ref="'progressPopup_' + skill.competencyId" :target="skill.competencyId" triggers="click" container="skillsTagsPopover">
                          <template slot="title">
                            <div class="header-title">
                              <span class="entity-title ace_sec_hd" :aria-label="skill.title">{{skill.title}}</span>
                              <button class="btn close-btn" aria-label="close" @click="closeProgressPopup(skill.competencyId)">
                                <span class="ic-close"></span>
                              </button>
                            </div>
                          </template>
                          <div class="popover_content">
                            <div class="row_hd">Courses and Co-curriculars (Job/Club/Event)</div>
                            <div v-if="skill.skillFulfillments.length > 0">
                              <div class="tags_container">
                                <template v-for="(fulFillment, index) in skill.skillFulfillments">
                                  <div class="row" :class="'popup_entity_' + fulFillment.entityType.toLowerCase()">
                                    <div class="mt-1">
                                      <span style="text-transform: capitalize;">{{fulFillment.entityType.toLowerCase()}}:</span>
                                    </div>
                                    <div class="tag ml-1">
                                      <span class="tag_name" style="color: #fff; width: 100%; max-width: 294px;" :title="fulFillment.entityTitle" :style="{background: skillStatusColorMap[skillStatusMap['' + fulFillment.status]]}">{{fulFillment.entityTitle}}</span>
                                    </div>
                                  </div>
                                </template>
                              </div>
                            </div>
                            <div v-else>
                              <span>No Courses and Co-curriculars (Job/Club/Event)</span>
                            </div>
                          </div>
                        </b-popover>
                      </template>
                    </div>
                  </div>
                </div>
              </template>
            </template>
          </div>
        </div>
      </div>
      <div class="col-11 dasboard-left-section" v-else-if="!showLoader">
        <div class="course-description col-12">
          <b-jumbotron>
            <h4 class="text-center ace_sec_txt" aria-label="Career View is currently not available">Career View is currently not available.</h4>
            <p class="text-center ace_sec_txt" aria-label="Please reach out to your institutional admin to unlock the Career View">Please reach out to your institutional admin to unlock the Career View.</p>
          </b-jumbotron>
        </div>
      </div>
    </div>
    <div class="loading-spinner">
      <b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
        <div class="text-center" style="color: #FFF">
          <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
  import { mapState, mapActions } from 'vuex'
  import StreamMenu from './StreamMenu'
  import StreamHeader from './StreamHeader'
  import { PACKAGE } from '../../../package_constants'
  import * as d3 from 'd3'

  export default {
    name: 'streamCareer',
    props: ['uuid'],
    components: {
      StreamMenu,
      StreamHeader
    },
    data: () => {
      return {
        tabIndex: 0,
        uObj: JSON.parse(localStorage.getItem('userobj')),
        userrole: localStorage.getItem('userrole'),
        showLoader: false,
        careerTypesMap: {
          'HARD': 'Hard Skills',
          'SOFT': 'Soft Skills',
          'CERTIFICATION': 'Certifications',
          'SKILL': 'Skills',
          'ABILITY': 'Abilities',
          'KNOWLEDGE': 'Knowledge',
          'BASELINE': 'Foundational Skills',
          'SPECIALIZED': 'Specialized Skills',
          'TOTAL': 'Overall'
        },
        skillTypeColorMap: {
          'HARD': '#ed8b05',
          'SOFT': '#e91e63',
          'CERTIFICATION': '#9c27b0',
          'SKILL': '#8d5202',
          'ABILITY': '#d782ff',
          'KNOWLEDGE': '#5bb2f5',
          'BASELINE': '#ed8b05',
          'SPECIALIZED': '#e91e63',
          'TOTAL': '#454545'
        },
        skillProgressLabelMap: {
          'completed': 'Completed',
          'inProgress': 'In Progress',
          'planned': 'In the Plan',
          'missing': 'Missing'
        },
        // typeAndProgressMap: {},
        careerProgressMapTypeAndProgressMap: {},
        skillStatusMap: {
          '2': 'Completed',
          '1': 'In Progress',
          '0': 'In the Plan',
          '-1': 'Missing'
        },
        skillStatusColorMap: {
          'Completed': '#528016',
          'In Progress': '#a1c75f',
          'In the Plan': '#f5b318',
          'Missing': '#cf7908'
        },
        // typeStatusAndTagMap: {},
        careerProgressMapTypeStatusAndTagMap: {},
        competencyTagSourceLabelMap: {
          'EMSI': 'EMSI',
          'COS': 'Career One Stop',
          'BGT': 'Burning Glass Technologies',
          'MIT': 'MIT',
          'NACE': 'NACE'
        }
      }
    },

    mounted () {
      this.loadStream()
    },

    updated () {
      this.$nextTick(() => {
        let sources = Object.keys(this.careerProgressMapTypeAndProgressMap)
        sources.forEach(source => {
          let typeAndProgressMap = this.careerProgressMapTypeAndProgressMap[source]
          let keys = Object.keys(typeAndProgressMap)
          if (keys.length > 0) {
            keys.forEach((key, i) => {
              let data = typeAndProgressMap[key]
              let circleColor = this.skillTypeColorMap[key]
              this.generateDonutChart(data, circleColor, 'skillPieChart_' + source + '_' + i)
            })
          }
        })
      })
    },

    methods: {
      ...mapActions([
        'loadStreamDetail',
        'loadUserAdvisor',
        'loadCategory',
        'loadLogDashboardActivity'
      ]),

      loadStream () {
        // DO NOT COMMENT OUT SHOW LOADER. This is used for other purposes too.
        this.showLoader = true
        this.$refs.loadingModal.show()
        this.loadLogDashboardActivity({action: 'viewStreamCareerView', page: 'streamCareerView', link: '', entityUuid: this.uuid})
        this.loadStreamDetail(this.uuid).then(res => {
          this.loadUserAdvisor(this.stream.ownerId)
          if (this.stream.careerProgressMap) {
            let sources = Object.keys(this.stream.careerProgressMap)
            this.careerProgressMapTypeAndProgressMap = {}
            this.careerProgressMapTypeStatusAndTagMap = {}
            sources.forEach(source => {
              let careerProgress = this.stream.careerProgressMap[source]
              if (careerProgress.progressByTypeMap) {
                let typeAndProgressMap = {}
                let types = Object.keys(careerProgress.progressByTypeMap)
                let isShowAllDonut = (types.includes('EXTRA')) ? (types.length > 3) : (types.length > 2)
                types.forEach(type => {
                  if (isShowAllDonut) {
                    if (type !== 'EXTRA') {
                      let progress = careerProgress.progressByTypeMap[type]
                      if (progress) {
                        let data = []
                        let keys = Object.keys(progress)
                        keys.forEach(key => {
                          let value = progress[key]
                          let label = this.skillProgressLabelMap[key]
                          if (label && value > 0) {
                            data.push({label: label, value: value})
                          }
                        })
                        typeAndProgressMap[type] = data
                      }
                    }
                  } else {
                    if (type === 'TOTAL') {
                      let progress = careerProgress.progressByTypeMap[type]
                      if (progress) {
                        let data = []
                        let keys = Object.keys(progress)
                        keys.forEach(key => {
                          let value = progress[key]
                          let label = this.skillProgressLabelMap[key]
                          if (label && value > 0) {
                            data.push({label: label, value: value})
                          }
                        })
                        typeAndProgressMap[type] = data
                      }
                    }
                  }
                })
                this.careerProgressMapTypeAndProgressMap[source] = typeAndProgressMap
              }

              if (careerProgress.careerSkills && careerProgress.careerSkills.length > 0) {
                let statusMap = {}
                let careerSkills = careerProgress.careerSkills
                careerSkills.forEach(careerSkill => {
                  let status = '' + ((careerSkill.status >= 2) ? 2 : careerSkill.status)
                  let keys = Object.keys(statusMap)
                  if (keys.includes(status)) {
                    statusMap[status].push(careerSkill)
                  } else {
                    let skills = [careerSkill]
                    this.$set(statusMap, status, skills)
                  }
                })

                let typeStatusAndTagMap = {}
                let keys = Object.keys(statusMap)
                if (keys.length > 0) {
                  keys.sort().reverse().forEach(key => {
                    let label = this.skillStatusMap[key]
                    this.$set(typeStatusAndTagMap, label, statusMap[key])
                  })
                }
                this.careerProgressMapTypeStatusAndTagMap[source] = typeStatusAndTagMap
              }
            })
          }
          this.showLoader = false
          this.$refs.loadingModal.hide()
        })
      },

      generateDonutChart (data, circleColor, elementId) {
        $('#' + elementId).empty()
        let pieChartContainerHeight = 162
        let pieChartInnerRadius = 35
        let width = pieChartContainerHeight
        let height = pieChartContainerHeight
        let radius = pieChartContainerHeight / 2

        let colorScale = this.skillStatusColorMap

        let tooltip = d3.select('body')
                      .append('div')
                      .style('position', 'absolute')
                      .style('z-index', '10')
                      .style('visibility', 'hidden')
                      .style('color', '#111')
                      .attr('class', 'report-tooltip-xaxis')
                      .style('padding', '8px')
                      .style('border-radius', '6px')
                      .style('font', 'bold 15px Arial')
                      .text('tooltip')

        let canvas = d3.select('#' + elementId).append('svg')
                     .data([data]).attr('width', width).attr('height', height).append('g')
                     .attr('transform', 'translate(' + radius + ',' + radius + ')')

        let circleRadius = radius / 2
        canvas.append('svg:circle')
              .attr('r', circleRadius * 0.6)
              .style('fill', circleColor)

        let arc = d3.arc()
                  .outerRadius(radius)
                  .innerRadius(pieChartInnerRadius)

        let pie = d3.pie()
                  .value(function (d) { return d.value }).sort(null)

        let arcs = canvas.selectAll('.arc')
                   .data(pie(data))
                   .enter().append('g')
                   .attr('class', 'arc')

        arcs.append('path')
            .attr('d', arc)
            .style('fill', function (d, i) { return colorScale[d.data.label] })
            .on('mouseover', function (d) {
              tooltip.text(d.data.label + ': ' + d.data.value + (''))
              tooltip.style('visibility', 'visible')
            })
            .on('mousemove', function () {
              return tooltip.style('top', (d3.event.pageY - 25) + 'px').style('left', (($(window).width() - 150) > d3.event.pageX ? (d3.event.pageX + 10) : (d3.event.pageX - 130)) + 'px')
            })
            .on('mouseout', function () {
              return tooltip.style('visibility', 'hidden')
            })

        arcs.append('text')
            .attr('transform', function (d) { return 'translate(' + arc.centroid(d) + ')' })
            .style('font', 'bold 12px Arial')
            .style('fill', '#fff')
            .style('cursor', 'default')
            .attr('text-anchor', 'middle')
            .text(function (d) { return d.data.value })
            .on('mouseover', function (d) {
              tooltip.text(d.data.label + ': ' + d.data.value + (''))
              tooltip.style('visibility', 'visible')
            })
            .on('mousemove', function () {
              return tooltip.style('top', (d3.event.pageY - 25) + 'px').style('left', (($(window).width() - 150) > d3.event.pageX ? (d3.event.pageX + 10) : (d3.event.pageX - 130)) + 'px')
            })
            .on('mouseout', function () {
              return tooltip.style('visibility', 'hidden')
            })
      },

      openProgressPopup (competencyId) {
        let ref = 'progressPopup_' + competencyId
        this.$root.$emit('bv::hide::popover')
        this.$refs[ref][0].$emit('open')
      },

      closeProgressPopup (competencyId) {
        let ref = 'progressPopup_' + competencyId
        this.$refs[ref][0].$emit('close')
      }
    },

    computed: {
      ...mapState({
        'stream': state => state.stream.stream,
        'advisor': state => state.user.advisor,
        'enabledFeatures': state => state.institution.enabledFeatures
      }),

      isCareerProgressAvailable () {
        if (this.stream && this.stream.careerProgressMap) {
          let sources = Object.keys(this.stream.careerProgressMap)
          if (sources && sources.length > 0) {
            let careerProgress = this.stream.careerProgressMap[sources[0]]
            if (careerProgress.progressByTypeMap) {
              let keys = Object.keys(careerProgress.progressByTypeMap)
              if (keys && keys.length > 1) {
                return true
              } else {
                return false
              }
            } else {
              return false
            }
          } else {
            return false
          }
        } else {
          return false
        }
      },

      advisorName () {
        if (this.advisor) {
          return this.advisor.name
        } else {
          return null
        }
      },

      advisorTitle () {
        if (this.userrole === 'Advisor' && this.stream && this.stream.ownerName) {
          return '' + this.stream.ownerName + ''
        } else {
          return ''
        }
      },

      showSkillLevel () {
        let skillTaggingFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SKILL_TAGGING_FEATURE_ID]
        if (skillTaggingFeature) {
          let flags = skillTaggingFeature.flags
          for (var i = 0; i < flags.length; i++) {
            if ((flags[i].title === 'sourceEMSI') && flags[i].enabled) {
              return false
            }
          }
        }
        return true
      }
    }
  }
</script>
<style scoped>
  .tag-type-head {
    width: 25%;
    margin-bottom: 12px;
    min-width: 325px;
  }
  .tag-type-status {
    padding: 15px 0px 15px 20px;
    font-size: 18px;
    font-weight: 800;
    color: #ffffff;
  }
  .tag-type-status-circle {
    height: 25px;
    width: 25px;
    border-radius: 50%;
    display: inline-block;
    border: 3px solid #fff;
    line-height: 16px;
    text-align: center;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  .popup_entity_job {
    padding-left: 20px;
  }
  .popup_entity_club {
    padding-left: 14px;
  }
  .popup_entity_event {
    padding-left: 9px;
  }
</style>



// WEBPACK FOOTER //
// src/app/stream/components/StreamCareer.vue